/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { CSSProperties } from 'react';
import style from './index.module.css';

type Props = {
    [key: string]: any;
    style: CSSProperties;
    isActive: boolean;
    isDisabled: boolean;
};

const Handle = ({ handleRef, style: inlineStyle, isActive, isDisabled, orientation, ...props }: Props) => (
    <button
        type="button"
        className={`${style.handle} 
      ${isActive ? style.active : ''}
      ${isDisabled ? style.disabled : ''} ${orientation === 'horizontal' ? style.horizontal : ''}`}
        ref={props.handleRef}
        style={inlineStyle}
        {...props}
    />
);
export default Handle;
